import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const BADGE_INFO = {
  'L+Bozo': { name: 'L+Bozo', tooltip: 'Took an L on your first spin. Bozo!' },
  nicecockbro: { name: 'nicecockbro', tooltip: 'Earned 10 wins combined' },
  rimwizard: { name: 'rimwizard', tooltip: 'Earned 25 wins combined' },
  assmaster: { name: 'assmaster', tooltip: 'Earned 50 wins combined' },
  thundercock: { name: 'thundercock', tooltip: 'Earned 100 wins combined' },
  cockjugglingthundercunt: { name: 'cockjugglingthundercunt', tooltip: 'Won the mega prize - front page feature!' },
  fillibuster: { name: 'fillibuster', tooltip: 'Won 10 votes on the leaderboard' },
  luckydog: { name: 'luckydog', tooltip: 'First spin again win' },
};

// Map badge names to their actual filenames (handles special cases like L+Bozo -> lbozo)
const getBadgeFilename = (badgeName) => {
  if (!badgeName) return badgeName;
  
  const filenameMap = {
    'L+Bozo': 'lbozo',
    'l+bozo': 'lbozo',
    'L+bozo': 'lbozo',
    'l+Bozo': 'lbozo',
  };
  
  // Check exact match first
  if (filenameMap[badgeName]) {
    return filenameMap[badgeName];
  }
  
  // Fallback to lowercase version of badge name
  return badgeName.toLowerCase();
};

export function UserBadge({ badgeName, className = "" }) {
  const badge = BADGE_INFO[badgeName];
  if (!badge) return null;

  // Map badge name to actual filename
  const badgeImage = `/assets/badges/${getBadgeFilename(badgeName)}.png`;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`text-[#FFD700] font-bold text-sm md:text-base ml-1.5 cursor-help inline-block ${className}`}>
            <img
              src={badgeImage}
              alt={badge.name}
              className="w-5 h-5 md:w-6 md:h-6 object-contain"
              onError={(e) => {
                // Fallback to text if image doesn't exist
                e.target.style.display = 'none';
                e.target.nextSibling?.remove();
                const text = document.createElement('span');
                text.textContent = badge.name.substring(0, 3).toUpperCase();
                text.className = 'text-[#FFD700]';
                e.target.parentElement.appendChild(text);
              }}
            />
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{badge.tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

